import { ReactNode, useRef, useState } from "react";
import {
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
  Button,
  useDisclosure,
} from "@chakra-ui/react";

interface ConfirmationOptions {
  title: string;
  description: ReactNode;
  actions?: [string, string];
  onConfirm: (() => Promise<void>) | (() => void);
  onCancel?: (() => Promise<void>) | (() => void);
}
export function useConfirmation() {
  const cancelRef = useRef(null);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [{ title, description, actions, onConfirm, onCancel }, setOptions] =
    useState<Partial<ConfirmationOptions>>({});

  const handleConfirm = async () => {
    await onConfirm?.();
    onClose();
  };

  const handleCancel = () => {
    onCancel?.();
    onClose();
  };

  const node = (
    <AlertDialog
      isOpen={isOpen}
      leastDestructiveRef={cancelRef}
      onClose={onClose}
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            {title}
          </AlertDialogHeader>

          <AlertDialogBody>{description}</AlertDialogBody>

          <AlertDialogFooter>
            <Button ref={cancelRef} onClick={handleCancel}>
              {actions?.[0] ?? "No"}
            </Button>
            <Button colorScheme="red" onClick={handleConfirm} ml={3}>
              {actions?.[1] ?? "Yes"}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );

  return {
    node,
    open: (options: ConfirmationOptions) => {
      setOptions(options);
      onOpen();
    },
  };
}
